function mibRollDice() {
  const dice = document.getElementById('mib-dice');
  const text = document.getElementById('mib-dice-text');

  if (!dice || !text) return;

  const faces = ['⚀', '⚁', '⚂', '⚃', '⚄', '⚅'];
  let rolls = 0;

  text.textContent = 'Even rollen...';

  const animation = setInterval(function () {
    const temp = Math.floor(Math.random() * 6);
    dice.textContent = faces[temp];
    rolls++;

    if (rolls >= 10) {
      clearInterval(animation);

      const result = Math.floor(Math.random() * 6);
      dice.textContent = faces[result];
      text.textContent = 'Je gooide ' + (result + 1) + '!';
    }
  }, 70);
}

window.mibRollDice = mibRollDice;